import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetTonePriceRequest } from './gettonepricerequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class GetTonePriceAPI extends SixdeeCRBTAPI<GetTonePriceRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-tone-price
        return "get-tone-price";
    }

    getRequestData()
    {
        return "clientTxnId=1710219007"+"&"+
               "language="+ (this.getRequest().getGetTonePriceRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
               "serviceId="+ this.getRequest().getGetTonePriceRequest().getServiceId()+"&"+
               "aPartyMsisdn="+ this.getRequest().getGetTonePriceRequest().getAPartyMsisdn()+"&"+
               "bPartyMsisdnList="+  
               this.getRequest().getGetTonePriceRequest().getBPartyMsisdnList()+ "&"+
               "toneId="+ this.getRequest().getGetTonePriceRequest().getToneId()+"&"+
               "validationIdentifier="+ this.getRequest().getGetTonePriceRequest().getValidationIdentifier()+"&"+
               "channelId="+ this.getRequest().getGetTonePriceRequest().getChannelId();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepriceapi.tsx